// Petit client API : ajoute REACT_APP_BACKEND_URL + token JWT si présent.

const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "lpl_admin_token";

export function getToken() {
    return typeof window !== "undefined"
        ? window.localStorage.getItem(TOKEN_KEY)
        : null;
}

export function setToken(token) {
    if (typeof window === "undefined") return;
    if (token) window.localStorage.setItem(TOKEN_KEY, token);
    else window.localStorage.removeItem(TOKEN_KEY);
}

async function request(path, { method = "GET", body, auth = false } = {}) {
    const headers = { Accept: "application/json" };
    if (body !== undefined) headers["Content-Type"] = "application/json";
    if (auth) {
        const t = getToken();
        if (t) headers["Authorization"] = `Bearer ${t}`;
    }

    const res = await fetch(`${BASE}${path}`, {
        method,
        headers,
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });

    if (res.status === 204) return null;

    const text = await res.text();
    const data = text ? JSON.parse(text) : null;

    if (!res.ok) {
        const detail = data && data.detail;
        const msg = formatDetail(detail) || `Erreur ${res.status}`;
        const err = new Error(msg);
        err.status = res.status;
        throw err;
    }
    return data;
}

function formatDetail(detail) {
    if (!detail) return null;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : null))
            .filter(Boolean)
            .join(" · ");
    return String(detail);
}

// ---- Public ----
export const publicApi = {
    listMontures: () => request("/api/montures"),
    getPopup: () => request("/api/popup"),
};

// ---- Auth ----
export const authApi = {
    login: (email, password) =>
        request("/api/auth/login", { method: "POST", body: { email, password } }),
    me: () => request("/api/auth/me", { auth: true }),
};

// ---- Admin ----
export const adminApi = {
    listMontures: () => request("/api/admin/montures", { auth: true }),
    createMonture: (data) =>
        request("/api/admin/montures", { method: "POST", body: data, auth: true }),
    updateMonture: (id, data) =>
        request(`/api/admin/montures/${id}`, {
            method: "PUT",
            body: data,
            auth: true,
        }),
    deleteMonture: (id) =>
        request(`/api/admin/montures/${id}`, { method: "DELETE", auth: true }),
    getPopup: () => request("/api/admin/popup", { auth: true }),
    updatePopup: (data) =>
        request("/api/admin/popup", { method: "PUT", body: data, auth: true }),
};
